import React from "react";
import Icon from "./Icon";

// A 3D envelope: when `open`, the flap tips back and the card inside
// slides up out of the pocket. Drawn with SVG so the edges stay crisp.
export default function Envelope3D({
  open,
  width = 170,
  tone = "pink",
  float = true,
  children,
}: {
  open: boolean;
  width?: number;
  tone?: "pink" | "blue";
  float?: boolean;
  children?: React.ReactNode;
}) {
  const fill = tone === "pink" ? "#f5a9b8" : "#9fe0fb";
  const flap = tone === "pink" ? "#ec8fa6" : "#7fd5f9";
  return (
    <span
      className={`env3d ${tone === "pink" ? "env-pink" : "env-blue"}${open ? " is-open" : ""}${float ? " env-float" : ""}`}
      style={{ "--env-w": `${width}px` } as React.CSSProperties}
      aria-hidden="true"
    >
      <span className="env-back" />
      <span className="env-card">{children}</span>
      <svg className="env-front" viewBox="0 0 100 66" preserveAspectRatio="none">
        <polygon
          points="1,3 50,40 99,3 99,65 1,65"
          fill={fill}
          stroke="#4a3426"
          strokeWidth="2"
          vectorEffect="non-scaling-stroke"
          strokeLinejoin="round"
        />
        <polyline
          points="1,65 41,35"
          fill="none"
          stroke="#4a3426"
          strokeWidth="1.5"
          vectorEffect="non-scaling-stroke"
          opacity="0.6"
        />
        <polyline
          points="99,65 59,35"
          fill="none"
          stroke="#4a3426"
          strokeWidth="1.5"
          vectorEffect="non-scaling-stroke"
          opacity="0.6"
        />
      </svg>
      <span className="env-flap">
        <svg viewBox="0 0 100 60" preserveAspectRatio="none">
          <polygon
            points="1,1 99,1 50,58"
            fill={flap}
            stroke="#4a3426"
            strokeWidth="2"
            vectorEffect="non-scaling-stroke"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <span className="env-seal">
        <Icon name="heart" size={Math.round(width / 12)} tone="white" />
      </span>
    </span>
  );
}
